<style lang="scss" src="./ActividadLista.scss"></style>
<template src="./ActividadLista.html"></template>

<script>
// import csvToJson from "convert-csv-to-json";
// import csvToJson from "@/components/Shared/ExportToFile/ExportToJSON"
import papa from 'papaparse'
import { Breadcrumb, BreadcrumbItem, Button, Dialog } from "element-ui";
import { requestAfiliacionMixin } from "@/api/ciudadano/afiliacionApi";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import { NotifyMixin } from "@/mixins/NotifyMixin";
import TipoSolicitud from "@/components/Ciudadano/ResumenTramites/TipoSolicitud/TipoSolicitud";
import VerAfiliacion from "@/components/Ciudadano/ResumenTramites/VerAfiliacion/VerAfiliacion";
import moment from "moment";
import ViewRenuncia from "@/components/Ciudadano/ResumenTramites/ViewRenuncia/ViewRenuncia";
import ActividadTabla from "@/components/Ciudadano/ResumenTramites/ActividadTabla/ActividadTabla";

import { utils } from "@/utils";
import { ExportToFileMixin } from "@/mixins/exportToFile";
import { BrotliMixin } from "@/mixins/BrotliMixin";
import ViewReclaim from "@/components/Ciudadano/ResumenTramites/ViewReclaim/ViewReclaim";
import ViewSolicitudHistorica from "@/components/Ciudadano/ResumenTramites/ViewSolicitudHistorica/ViewSolicitudHistorica";
import ViewGenCertificado from "@/components/Ciudadano/ResumenTramites/ViewGenCertificado/ViewGenCertificado";
import { FileDownloadMixin } from "@/mixins/FileDownload";

export default {
  name: "ActividadLista",
  components: {
    ActividadTabla,
    VerAfiliacion,
    ViewRenuncia,
    ViewReclaim,
    ViewSolicitudHistorica,
    ViewGenCertificado,
    TipoSolicitud,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
  },
  data: () => ({
    dlgVerSolicitud: false,
    id: "",
    tipoCodigo: 0,
    module: "",
    loading: false,
    errored: false,
    header: [
      "Identificador",
      "Rut",
      "Nombres",
      "Paterno",
      "Materno",
      "Fecha",
      "Tipo",
      "Estado",
    ],
    filter: [
      "id",
      "run",
      "nombres",
      "paterno",
      "materno",
      "fechacompleta",
      "nombremodulo",
      "estado",
    ],
  }),
  mixins: [
    requestAfiliacionMixin,
    ScreenSizeMixin,
    NotifyMixin,
    ExportToFileMixin,
    BrotliMixin,
    FileDownloadMixin,
  ],
  computed: {
    dlgTitle: function () {
      return `${this.module} n° ${this.id}`;
    },
  },
  methods: {
    openModal(id, tipoCodigo, module) {
      this.$log.debug("openModal", id, tipoCodigo);
      this.id = id;
      this.tipoCodigo = tipoCodigo;
      this.module = module;
      this.dlgVerSolicitud = true;
    },
    onUndoAffiliation(id) {
      this.$log.debug("undoAffiliation", id);

      this.$confirm(
        "Cancelará la solicitud de afiliación, ¿Está seguro de que desea continuar?",
        "Portal Afiliación",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          await this.executeUndoAffiliation(id);
        })
        .catch(() => {
          this.showInfo("La solicitud de afiliación seguirá activa.");
        });
    },
    async executeUndoAffiliation(id) {
      const loading = this.getLoading();
      this.undoAffiliation(id)
        .then((response) => {
          this.$log.debug("undoAffiliation", response.data.statusCode);

          this.$refs.activityTable.refreshTabla();

          if (response.data.statusCode === 200) {
            this.showSuccess("Se ha cancelado su solicitud con éxito.");
          } else if (response.data.statusCode === 404) {
            this.showInfo(
              "No se ha podido cancelar la solicitud de afiliación."
            );
          } else {
            this.showError(
              "Ocurrió un error inesperado al cancelar la solicitud."
            );
          }
        })
        .catch((err) => {
          this.$log.fatal("undoAffiliation", err, err.response, err.request);
          this.showError("Ocurrió un error inesperado al cargar los datos");
        })
        .finally(() => {
          loading.close();
        });
    },
    closeModal() {
      this.dlgVerSolicitud = false;
    },
    fieldsToExport: function () {
      const list = this.header.map((h, i) => ({
        name: h,
        key: this.filter[i],
        disabled: false,
      }));
      this.$log.debug(list);
      return list;
    },
    async exportToExcel(querySearch = "") {
      this.querySearch = querySearch;
      const checkList = this.header;
      const fields = this.fieldsToExport(this.filter, this.header);
      this.$log.debug("exportToExcel", checkList, fields);
      const listField = this.getListField(checkList, fields);
      const data = await this.getList({ fields: listField });
      if (!this.errored) {
        const date = moment(new Date()).format("YYYYMMDDhhmmss");
        const filename = `resumen-tramites-${date}`;
        this.exportExcel(data, checkList, fields, filename);
      }
    },
    descargarComprobante(id) {
      const loading = this.getLoading();

      this.getComprobante(id)
        .then((response) => {
          this.$log.debug("getComprobante", response.data);

          if (response.data.statusCode === 200) {
            this.downloadFileDocument(response.data.datos);
          } else if (response.data.statusCode === 404) {
            this.$log.error(
              "No se encuentra la afiliación",
              response.data.datos
            );
            this.showError(
              "No se encuentra la afiliación para generar el comprobante"
            );
          } else {
            this.$log.error(
              "Error al generar el certificado",
              response.data.datos
            );
            this.showError(
              "Se ha producido un error al generar el comprobante, inténtelo nuevamente"
            );
          }
          loading.close();
        })
        .catch((err) => {
          this.$log.error(
            "Ocurrió un error inesperado al cargar el comprobante",
            err
          );
          loading.close();

          this.showError(
            "Ocurrió un error inesperado al cargar el comprobante"
          );
        });
    },
    onErrorClose() {
      this.dlgVerSolicitud = false;
    },
    getList({
      pageAll = true,
      search = this.querySearch,
      dateRange = this.dateFilter,
      fields = fields,
      format = "csv",
      compress = true,
    } = {}) {
      this.loading = true;
      const pagingQuery = {
        pageAll: pageAll,
        search: search,
        dateRange: dateRange,
        fields: fields,
        format: format,
        compress: compress,
      };

      const loading = this.getLoading();
      return this.getListaActividad(pagingQuery)
        .then((response) => {
          this.$log.debug("getListaActividad", response.data.statusCode);

          if (response.data.statusCode === 200) {
            const data = this.decompress(response.data.datos);
            this.$log.debug(data);
            let dataformat = data;
            if (pagingQuery.format === "csv") {
             //  dataformat = csvToJson.fieldDelimiter(";").csvStringToJson(data);
              dataformat =  papa.parse(data)

            }

            const datasource = dataformat.data.map((row) => {
              row.run = utils.rutFilter(row.run);
              return row;
            });
            this.$log.debug(datasource);
            this.errored = false;

            return datasource;
          } else {
            this.errored = true;
            this.showError("Ocurrió un error inesperado al cargar los datos");
          }
          return [];
        })
        .catch((err) => {
          this.$log.fatal("getListaActividad", err, err.response, err.request);
          this.errored = true;
          this.showError("Ocurrió un error inesperado al cargar los datos");
        })
        .finally(() => {
          this.loading = false;
          loading.close();
        });
    },
  },
};
</script>
